import ToastHighLighter from '@/lib/ToastHighLighter';

export const SpinnerCode = () => {
  const language = 'html';
  const codeString = `
  // Spinner
  <div className="d-flex justify-content-center align-content-center p-7">
    <div className="spinner-border" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>

  <div className="d-flex justify-content-center align-content-center bg-black p-7 bg-opacity-100">
    <div className="spinner-border text-white" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
`;

  return (
    <>
      <ToastHighLighter
        name={'spinner'}
        codeString={codeString}
        language={language}
        show={true}
      />
    </>
  );
};
